<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-6">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" />
        </div>
        <div>
          <label class="label-input">Layout</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div>
                  <label>Background Color</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      style="width: 40px; height: 40px; margin-right: 12px"
                      type="color"
                      v-model="fields.settings.backgroundColor"
                    />
                    <v-text-field class="mb-0 mt-0" v-model="fields.settings.backgroundColor" hide-details />
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <label>Text Color</label>
                  <div class="d-flex align-center gap-3">
                    <input
                      style="width: 40px; height: 40px; margin-right: 12px"
                      type="color"
                      v-model="fields.settings.textColor"
                    />
                    <v-text-field class="mb-0 mt-0" v-model="fields.settings.textColor" hide-details />
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.settings.paddingTop"
                  label="Top Padding"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-checkbox
                  class="mb-0 mt-0"
                  v-model="fields.settings.paddingBottom"
                  label="Bottom Padding"
                  dense
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <div>
                  <v-checkbox
                    class="mb-3 mt-0"
                    v-model="fields.containerPage.enableStyle"
                    label="Enable Style Container"
                    dense
                    hide-details
                  />
                  <div v-if="fields.containerPage.enableStyle">
                    <label>Background Color</label>
                    <div class="d-flex align-center gap-3">
                      <input
                        style="width: 40px; height: 40px; margin-right: 12px"
                        type="color"
                        v-model="fields.containerPage.background"
                      />
                      <v-text-field class="mb-0 mt-0" v-model="fields.containerPage.background" hide-details />
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div>
          <label class="label-input">Content</label>
          <div>
            <ckeditor class="mt-4" :editor="editor" v-model="fields.content" :config="editorConfig" />
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>
<script>
import { updateHtmlFromData } from '@/views/website/themes/homepage/common/html/update';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
export default {
  name: 'freestyle-section-editor',
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        content: '',
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionFreestyle(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.group-item {
  border: 1px solid #0000000f;
  padding: 16px 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
</style>
